import { render, staticRenderFns } from "./informativacookies.vue?vue&type=template&id=12b4595d"
import script from "./informativacookies.vue?vue&type=script&lang=js"
export * from "./informativacookies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports